import { getCurrentMagentoClient } from "@magento/clients/getClient";
import type { IGetStockStatusesQuery } from "@magento/types";

import type { UseQueryResult } from "@jti/rest-api";
import { useQuery } from "@jti/rest-api";

type UseStockStatusesParams<T> = {
  categoriesSKUList: string[];
  isTrial?: boolean;
  onSuccess?: (data: T) => void;
  select?: (data: IGetStockStatusesQuery) => T;
};

export function useStockStatuses(skus?: string[]): UseQueryResult<IGetStockStatusesQuery>;
export function useStockStatuses<T = IGetStockStatusesQuery>(params: UseStockStatusesParams<T>): UseQueryResult<T>;
export function useStockStatuses<T = IGetStockStatusesQuery>(
  params: string[] | undefined | UseStockStatusesParams<T>
): UseQueryResult<T> {
  const isLegacyParams = Array.isArray(params) || params === undefined;
  const categoriesSKUList = isLegacyParams ? (params ?? []) : params.categoriesSKUList;
  const isTrial = isLegacyParams ? false : (params.isTrial ?? false);
  const onSuccess = isLegacyParams ? undefined : params.onSuccess;
  const select = isLegacyParams ? undefined : params.select;
  const magentoClient = getCurrentMagentoClient(isTrial);

  const queryState = useQuery<IGetStockStatusesQuery, unknown, T>(
    ["STOCK_STATUSES", ...categoriesSKUList, { isTrial }],
    () => magentoClient.getStockStatuses(categoriesSKUList, categoriesSKUList.length),
    {
      enabled: categoriesSKUList.length > 0,
      onSuccess,
      select,
    }
  );

  return queryState;
}
